import { ChangeDetectorRef, Component, forwardRef, Inject } from '@angular/core';
import { LoadingController, NavController, NavParams, Platform, ToastController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { EbsComponentService } from "../../services/ebsComponentService";
import { Vibration } from '@ionic-native/vibration';
import { BarcodeFunction } from '../../functions/barcode';
import { Events } from 'ionic-angular';
declare var $;

@Component({
  selector: 'page-scanner',
  templateUrl: 'scanner.html',
})

export class ScannerPage {
  title: string;
  result: any;
  public switch_status: boolean = false;
  private active_green: boolean = false;
  private active_orange: boolean = false;
  private active_red: boolean = false;
  public scans = [];
  private scan_url: string = "";
  private scan_params: string = "";
  private finish_url: string = "";
  private finish_params: string = "";
  private dataUrl: string = "";
  public showTestButtons: boolean = true;
  private test_code: string;
  private finish_viewTypeAction: string = "";
  orders: any = {};

  public constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private vibration: Vibration,
    private barcodeFunction: BarcodeFunction,
    public events: Events,
    private platform: Platform,
    private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
    public loadingCtrl: LoadingController,
    private cdRef: ChangeDetectorRef,
    public toastController: ToastController) {
    this.dataUrl = navParams.get('actionURL');
    //events.publish("reloadMenu");
  }

  sendCodeToWebservice(code) {

    let scan_post_params = this.scan_params + code;
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(scan_post_params);
    let sub = this._ebsWebService.postData(this.scan_url, postPayloadObject);

    console.log("scan_post_params", scan_post_params);
    console.log("postPayloadObject", postPayloadObject);
    console.log("sub", sub);
    console.log("this.scanurl", this.scan_url);

    sub.subscribe(res => {
      console.log("scanning");
      console.log(res);
      if (res != null) {
        if (res.Caption == "TOO_OFTEN_REQUEST_SKIPPED") {
          const toast = this.toastController.create({
            message: 'Zu schnell gescannt!',
            duration: 2200,
            cssClass: "toast-scan-error"
          });
          toast.present();
          return;
        } else if (res.ListItemNavigation != "" && res.ListItemNavigation != null) {
          console.log("yes");
          this.getGroupedArticlesForScanning(res.ListItemNavigation);
          this.getScannerActions(res.ListItemAction);
          this.cdRef.detectChanges();
          // Todo Scroll to Scanned articel
          // } else if (res != null && res.Caption == "BARCODE_NOT_FOUND") { this.openPage(res.ListItemAction[0]); }
          // } else { return; }
        } else {
          console.log("not found");
          this.openPage(res.ListItemAction[0]);
        }
      } else {
        console.log("res null");
        return;
      }
      this.cdRef.detectChanges();
    });
  }

  sendTestCode() {
    console.log(this.test_code);
    if (this.test_code) {
      this.sendCodeToWebservice(this.test_code);
    }
  }


  finishOrder() {
    let item = { ActionUrl: this.finish_url, PostParameters: this.finish_params, title: "", ViewTypeAction: this.finish_viewTypeAction };
    this.openPage(item);
  }

  ionViewWillEnter() {
    this.platform.ready().then(() => {


      if (this.platform.is('android') || this.platform.is('mobileweb')) {
        this.showTestButtons = false;
      }

      this.events.subscribe('data:scan', (scanData, time) => {
        let scannedData = scanData.extras["com.symbol.datawedge.data_string"];
        console.log("events");
        this.sendCodeToWebservice(scannedData);
        this.vibration.vibrate([100]);
        this.cdRef.detectChanges();
      });

      if (this.dataUrl != "") {
        this.loadRawArticleData(this.dataUrl);
      }
    });
  }

  ionViewWillLeave() {
    console.log("leave");
    this.events.unsubscribe('data:scan', null);
  }

  loadRawArticleData(dataUrl) {
    let loading = this.loadingCtrl.create({
      content: 'Bitte warten...'
    });
    loading.present();
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
    this._ebsWebService.postData(dataUrl, postPayloadObject).subscribe(res => {
      if (typeof res != "undefined" && res != null) {
        this.getGroupedArticlesForScanning(res.ListItemNavigation);
        console.log("res", res.ListItemNavigation);
        this.getScannerActions(res.ListItemAction);
        this.title = res.MainTitle;
        this._ebsWebService.setBrowserTabTitle(res.MainTitle);
        this.cdRef.detectChanges();
        loading.dismiss();
      }
    });
  }

  getScannerActions(actions) {
    console.log("§asdfadsf", actions);
    actions.forEach(action => {
      if (action.ActionName == "View") {
        this.scan_url = action.ActionUrl;
        this.scan_params = action.PostParameters;
      }
      if (action.ActionName == "Finish") {
        this.finish_url = action.ActionUrl;
        this.finish_params = action.PostParameters;
        this.finish_viewTypeAction = action.ViewTypeAction;
      }
    })
  }

  getGroupedArticlesForScanning(articles) {
    this.orders = {};
    articles.forEach((article) => {
      let articlePrepared = { statusColor: "", name: "", code: "", amount: "", caption: "", actionUrl: "", actionParams: "", ViewTypeAction: "", lieferant: "" };
      articlePrepared.actionUrl = article.Action;
      articlePrepared.actionParams = article.PostParameters;
      articlePrepared.ViewTypeAction = article.ViewTypeAction;
      article.ListItemContent.forEach((field) => {
        console.log("field", field.FieldName, field.DisplayText);
        switch (field.FieldName) {
          case "statusColor":
            articlePrepared.statusColor = field.LabelCaption;
            break;
          case "NameArt":
            articlePrepared.name = field.DisplayText;
            break;
          case "artCode":
            articlePrepared.code = field.DisplayText;
            break;
          case "menge":
            articlePrepared.amount = field.DisplayText;
            break;
          case "caption":
            articlePrepared.caption = field.DisplayText;
            break;
          case "Lieferant":
            articlePrepared.lieferant = field.DisplayText;
            break;
          default:
            articlePrepared.caption = field.DisplayText;
            break;
        }
      });
      if (this.orders[article.GroupDisplayName] === undefined) {
        let orderArray = [];
        orderArray.push(articlePrepared);
        this.orders[article.GroupDisplayName] = orderArray;
      } else {
        this.orders[article.GroupDisplayName].push(articlePrepared);
      }
    });
  }

  public fabDown() {
    this.barcodeFunction.sendCommand("com.symbol.datawedge.api.SOFT_SCAN_TRIGGER", "START_SCANNING");
  }

  public fabUp() {
    this.barcodeFunction.sendCommand("com.symbol.datawedge.api.SOFT_SCAN_TRIGGER", "STOP_SCANNING");
  }

  count_items(className) {
    return document.getElementsByClassName(className).length;
  }

  switch_articles(color) {
    switch (color) {
      case "green": {
        if (!this.active_green) {
          this.active_green = true;
          this.active_orange = false;
          this.active_red = false;
          this.show_articles("is_green");
          this.hide_articles(".is_red, .is_orange");
        } else {
          this.switch_all_articles();
        }
        break;
      }

      case "orange": {
        if (!this.active_orange) {
          this.active_orange = true;
          this.active_green = false;
          this.active_red = false;
          this.show_articles("is_orange");
          this.hide_articles(".is_green, .is_red");
        } else {
          this.switch_all_articles();
        }
        break;
      }

      case "red": {
        if (!this.active_red) {
          this.active_red = true;
          this.active_green = false;
          this.active_orange = false;
          this.show_articles("is_red");
          this.hide_articles(".is_green, .is_orange");
        } else {
          this.switch_all_articles();
        }
        break;
      }
    }

    $(".scanner-row").each(function () {
      let hasVisibleOrder = false;
      $(this).find(".scanner-col > scanner-component > .bestellung_card").each(function () {
        if ($(this).is(':visible')) {
          hasVisibleOrder = true;
        }
      });
      if (hasVisibleOrder) {
        $(this).find(".scanner-order-header").show();
      } else {
        $(this).find(".scanner-order-header").hide();
      }
    });
  }

  switch_all_articles() {
    this.show_all_articles();
    this.active_green = false;
    this.active_orange = false;
    this.active_red = false;
  }

  hide_articles(classes) {
    var elementsToHide = document.querySelectorAll(classes);
    for (var i = 0; i < elementsToHide.length; i++) {
      (elementsToHide[i] as HTMLElement).style.display = "none";
    }
  }

  show_articles(current_class) {
    var elementToShow = document.getElementsByClassName(current_class);
    for (var i = 0; i < elementToShow.length; i++) {
      (elementToShow[i] as HTMLElement).style.display = "block";
    }
  }

  show_all_articles() {
    var elementsToShow = document.getElementsByClassName("bestellung_card");
    for (var i = 0; i < elementsToShow.length; i++) {
      (elementsToShow[i] as HTMLElement).style.display = "block";
    }
  }

  openPage(item) {
    if (typeof item.ActionUrl != "undefined" && item.ActionUrl != "" && item.ActionUrl != null) {
      let navParams = { title: item.DisplayName, actionURL: item.ActionUrl, postParams: item.PostParameters };
      this._ebsComponentService.navigationController(item, navParams, this.navCtrl);
    } else {
      return;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/scanner/scanner.ts